import ReactApexChart from 'react-apexcharts';

const UserDistribution = ({ platformData = [] }) => {
    const validPlatforms = platformData.filter(item => item.OS !== null);
    const totalUsers = validPlatforms.reduce((sum, item) => sum + item.UserCount, 0);
    
    const doughnutSeries = validPlatforms.map(item => item.UserCount);
    const doughnutLabels = validPlatforms.map(item => item.OS || 'Unknown');
    
    const colorPalette = ['#342D56', '#CBA370', '#4CAF50', '#2196F3', '#FF9800'];

    const doughnutOptions = {
        chart: {
            type: 'donut',
            height: 350,
        },
        colors: colorPalette,
        labels: doughnutLabels,
        plotOptions: {
            pie: {
                donut: {
                    size: '70%',
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            showAlways: true,
                            label: 'Total Users',
                            fontSize: '16px',
                            fontWeight: 'normal',
                            color: '#342D56',
                            formatter: function (w) {
                                return totalUsers.toString();
                            }
                        },
                        value: {
                            show: true,
                            fontSize: '28px',
                            fontWeight: 'bold',
                            color: '#342D56',
                            offsetY: 0,
                        }
                    }
                }
            }
        },
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return val.toFixed(0) + '%';
            },
            dropShadow: {
                enabled: false
            }
        },
        legend: {
            position: 'right',
            horizontalAlign: 'left',
            fontSize: '14px',
            markers: {
                width: 12,
                height: 12,
                radius: 50,
            },
            itemMargin: {
                vertical: 4,
            }
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    legend: {
                        position: 'bottom'
                    }
                }
            }
        ],
        tooltip: {
            y: {
                formatter: function(val) {
                    return val + ' users';
                }
            }
        }
    };

    return (
        <div className="col-xxl-6 col-xl-12">
            <div className="card h-100 px-16 pt-16">
                    <h6 className="text-lg mb-0" style={{ color: '#342D56', fontWeight: 'bold' }}>
                        User Distribution by Platform
                    </h6>
                <div className="card-body d-flex flex-column aling-items-center justify-content-center">
                    {validPlatforms.length > 0 ? (
                        <ReactApexChart 
                            options={doughnutOptions} 
                            series={doughnutSeries} 
                            type="donut"
                            height={350} 
                        />
                    ) : (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '350px' }}>
                            <div className="text-center text-muted">
                                <p>No platform data available</p>
                            </div>
                        </div>
                    )}
                    </div>
            </div>
        </div>
    );
};

export default UserDistribution;